import React from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '../../../components/ui/Button';

const LoginPrompt = () => {
  const navigate = useNavigate();

  return (
    <div className="text-center space-y-4">
      <div className="relative">
        <div className="absolute inset-0 flex items-center">
          <div className="w-full border-t border-border" />
        </div>
        <div className="relative flex justify-center text-sm">
          <span className="px-4 bg-background text-muted-foreground">
            Already have an account?
          </span>
        </div>
      </div>

      <Button
        variant="outline"
        onClick={() => navigate('/user-login')}
        iconName="LogIn"
        iconPosition="left"
        className="w-full sm:w-auto"
      >
        Sign In Instead
      </Button>

      <div className="text-xs text-muted-foreground space-y-1">
        <p>
          By creating an account, you agree to our{' '}
          <button
            onClick={() => window.open('/terms', '_blank')}
            className="text-primary hover:underline"
          >
            Terms of Service
          </button>
          {' '}and{' '}
          <button
            onClick={() => window.open('/privacy', '_blank')}
            className="text-primary hover:underline"
          >
            Privacy Policy
          </button>
        </p>
        <p>
          Need help?{' '}
          <button
            onClick={() => window.open('/contact', '_blank')}
            className="text-primary hover:underline"
          >
            Contact Support
          </button>
        </p>
      </div>
    </div>
  );
};

export default LoginPrompt;